var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router, ActivatedRoute } from '@angular/router';
import { OnInit } from '@angular/core';
import { isArray } from 'lodash';
import { FormControl, FormGroup } from '@angular/forms';
import { CuiBaseComponent } from '@cicero/webui/lib/core/shared/base-component';
import { MaterialService } from '../material.service';
import { numberOfRequiredFieldsValidator } from '@cicero/webui/lib/core/validators/min-values.validator';
import 'rxjs/add/operator/filter';
var SearchFormComponent = /** @class */ (function (_super) {
    __extends(SearchFormComponent, _super);
    function SearchFormComponent(route, router, materialService) {
        var _this = _super.call(this) || this;
        _this.route = route;
        _this.router = router;
        _this.materialService = materialService;
        _this.searchForm = new FormGroup({
            branch: new FormControl(),
            department: new FormControl(),
            location: new FormControl(),
            sublocation: new FormControl(),
            theme: new FormControl([]),
            state: new FormControl()
        }, numberOfRequiredFieldsValidator(1));
        return _this;
    }
    SearchFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.options = this.materialService.getSearchOptions()
            .do(function (options) {
            var theme = options.themes.find(function (t) { return t.isDefault; });
            _this.defaultThemeId = theme && theme.id;
        });
        // Update the form when the url changes
        var querySub = this.route.queryParams
            .map(function (params) { return _this.paramsToQueryParams(params); })
            .subscribe(function (query) { return _this.searchForm.patchValue(query); });
        // Update the url when the form changes
        var valueChangesSub = this.searchForm.valueChanges
            .subscribe(function (params) { return _this.router.navigate([], { queryParams: params, replaceUrl: true }); });
        // Select the default theme, if no theme is selected
        var defaultSub = this.options
            .filter(function () { return !_this.searchForm.controls['theme'].value.length; })
            .filter(function () { return !!_this.defaultThemeId; })
            .subscribe(function (id) { return _this.searchForm.controls['theme'].setValue([_this.defaultThemeId]); });
        this.pushSubscription(querySub, valueChangesSub, defaultSub);
    };
    SearchFormComponent.prototype.reset = function () {
        this.searchForm.patchValue({
            branch: undefined,
            department: undefined,
            location: undefined,
            sublocation: undefined,
            theme: this.defaultThemeId ? [this.defaultThemeId] : [],
            state: undefined
        });
    };
    /**
     * Converts query parameters into a query params object used by the search form.
     * @param params
     * @returns {QueryParams}
     */
    SearchFormComponent.prototype.paramsToQueryParams = function (params) {
        var queryParams = {};
        if (params.branch) {
            queryParams.branch = params.branch;
        }
        if (params.department) {
            queryParams.department = params.department;
        }
        if (params.location) {
            queryParams.location = params.location;
        }
        if (params.sublocation) {
            queryParams.sublocation = params.sublocation;
        }
        if (params.theme) {
            queryParams.theme = isArray(params.theme) ? params.theme : [params.theme];
        }
        if (params.state) {
            queryParams.state = params.state;
        }
        return queryParams;
    };
    return SearchFormComponent;
}(CuiBaseComponent));
export { SearchFormComponent };



// WEBPACK FOOTER //
// ./src/app/material/search-form/search-form.component.ts.pre-build-optimizer.js